import SupervisorAccountIcon from '@mui/icons-material/SupervisorAccount';
import { createUserEdit } from '../users/UserEdit';
import { createUserList } from '../users/UserList';

const AdminUsersList = createUserList({
    resource: 'admin/user-management/admin-users',
    showRoleFilter: false,
    showImport: false,
    mode: 'admin',
});

const AdminUsersEdit = createUserEdit({
    resource: 'admin/user-management/admin-users',
    cancelPath: '/admin/user-management/admin-users',
    mode: 'admin',
});

export default {
    list: AdminUsersList,
    edit: AdminUsersEdit,
    icon: SupervisorAccountIcon,
    recordRepresentation: (record: any) => record.name || record.email,
};